import { render, staticRenderFns } from "./dialogTable.vue?vue&type=template&id=2790ec0e"
import script from "./dialogTable.vue?vue&type=script&lang=js"
export * from "./dialogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports